module.exports = __webpack_public_path__ + "img/bell-circle.2155bde.svg";